import { Separator } from "@/components/ui/separator";

interface DateSeparatorProps {
  date: Date;
  /** If provided, shows relative context like "2 hours ago" */
  relative?: string;
}

/**
 * Visual separator between messages from different time periods.
 * Shows the date as a centered label on a divider line.
 */
export function DateSeparator({ date, relative }: DateSeparatorProps) {
  const label = formatDateLabel(date, relative);

  return (
    <div className="py-2 mt-5 first:mt-0">
      <Separator label={label} />
    </div>
  );
}

function formatDateLabel(date: Date, relative?: string): string {
  const now = new Date();
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const messageDay = new Date(date.getFullYear(), date.getMonth(), date.getDate());
  const diffDays = Math.floor((today.getTime() - messageDay.getTime()) / 86400000);

  if (diffDays === 0) return relative ?? "Today";
  if (diffDays === 1) return "Yesterday";
  if (diffDays < 7) {
    return date.toLocaleDateString(undefined, { weekday: "long" });
  }

  return date.toLocaleDateString(undefined, {
    month: "short",
    day: "numeric",
    ...(date.getFullYear() !== now.getFullYear() && { year: "numeric" }),
  });
}
